import { LealSpinner } from '@lealco/system-design/dist/components/leal-spinner'
import { LealGrid } from '@lealco/system-design/dist/components/leal-grid'
import { LealRow } from '@lealco/system-design/dist/components/leal-row'
import { LealCol } from '@lealco/system-design/dist/components/leal-col'
import { LealBox } from '@lealco/system-design/dist/components/leal-box'
import { LealText } from '@lealco/system-design/dist/components/leal-text'
import { LealInput } from '@lealco/system-design/dist/components/leal-input'
import { LealButton } from '@lealco/system-design/dist/components/leal-button'
import { LealScrollBar } from '@lealco/system-design/dist/components/leal-scroll-bar'
import { LealTooltipCrm } from '@lealco/system-design/dist/components/leal-tooltip-crm'
import { LealIconDs} from '@lealco/system-design/dist/components/leal-icon-ds'
import { LealContentDs} from '@lealco/system-design/dist/components/leal-content-ds'
import { LealMenuDs} from '@lealco/system-design/dist/components/leal-menu-ds'
import { LealNavbarDs} from '@lealco/system-design/dist/components/leal-navbar-ds'
import { LealMobileMenuDs} from '@lealco/system-design/dist/components/leal-mobile-menu-ds'
import { LealProfileModalDs} from '@lealco/system-design/dist/components/leal-profile-modal-ds'
import { LealProfileImageDs} from '@lealco/system-design/dist/components/leal-profile-image-ds'
import { LealProfileDs} from '@lealco/system-design/dist/components/leal-profile-ds'
import { LealTooltipDs} from '@lealco/system-design/dist/components/leal-tooltip-ds'
import { LealHelpModalDs} from '@lealco/system-design/dist/components/leal-help-modal-ds'
import { LealToastDs} from '@lealco/system-design/dist/components/leal-toast-ds'
import { LealTextDs } from '@lealco/system-design/dist/components/leal-text-ds'


//types
import { WebCompontensArray } from './domain/models/webComponentesArray';
export const webComponents : WebCompontensArray[]= [
  {
    name:'leal-spinner',
    element:LealSpinner,
  },
  {
    name:'leal-grid',
    element:LealGrid,
  },
  {
    name:'leal-row',
    element:LealRow,
  },
  {
    name:'leal-col',
    element:LealCol,
  },
  {
    name:'leal-box',
    element:LealBox,
  },
  {
    name:'leal-text',
    element:LealText,
  },
  {
    name:'leal-input',
    element:LealInput,
  },
  {
    name:'leal-button',
    element:LealButton,
  },
  {
    name:'leal-scroll-bar',
    element:LealScrollBar
  },
  {
    name:'leal-tooltip-crm',
    element:LealTooltipCrm
  },
  {
    name:'leal-icon-ds',
    element:LealIconDs
  },
  {
    name:'leal-content-ds',
    element:LealContentDs
  },
  {
    name:'leal-menu-ds',
    element:LealMenuDs
  },
  {
    name:'leal-navbar-ds',
    element:LealNavbarDs
  },
  {
    name:'leal-mobile-menu-ds',
    element:LealMobileMenuDs
  },
  {
    name:'leal-profile-modal-ds',
    element:LealProfileModalDs
  },
  {
    name:'leal-profile-image-ds',
    element:LealProfileImageDs
  },
  {
    name:'leal-profile-ds',
    element:LealProfileDs
  },
  {
    name:'leal-tooltip-ds',
    element:LealTooltipDs
  },
  {
    name:'leal-help-modal-ds',
    element:LealHelpModalDs
  },
  {
    name:'leal-toast-ds',
    element:LealToastDs
  },
  {
    name:'leal-text-ds',
    element:LealTextDs,
  },
  ]
